export default function React_FirstApp() {
  return (
    <div>
      <h1>React_FirstApp Component</h1>
      <p>This is the React_FirstApp tutorial page.</p>
    </div>
  );
}
